module.exports = __webpack_public_path__ + "static/media/27-1.8e251c17.mp3";